import AllCategoriesIcon from './AllCategoriesIcon/AllCategoriesIcon';
import CrashIcon from './CrashIcon/CrashIcon';
import ClassicsIcon from './ClassicsIcon/ClassicsIcon';
import SlotsIcon from './SlotsIcon/SlotsIcon';
import TableGamesIcon from './TableGamesIcon/TableGamesIcon';

export const categoryIcons: CategoryIconsInterface = {
	slots: SlotsIcon,
	tablegames: TableGamesIcon,
	allcategories: AllCategoriesIcon,
	crash: CrashIcon,
	classics: ClassicsIcon,
};

export interface CategoryIconsInterface {
	slots: React.FC<React.SVGProps<SVGSVGElement>>;
	tablegames: React.FC<React.SVGProps<SVGSVGElement>>;
	allcategories: React.FC<React.SVGProps<SVGSVGElement>>;
	crash: React.FC<React.SVGProps<SVGSVGElement>>;
	classics: React.FC<React.SVGProps<SVGSVGElement>>;
}
